const css = `
  form[class*="_formFieldset_"],
  span[class*="_formFileInputButton_"],
  span[class*="_textBody_"],
  div[class*="_textBody_"] p,
  legend[class*="_checkboxLegend_"] {
    font-family: var(--text-font-family);
    color: rgb(var(--text-color));
    font-weight: 500;
  }
  [class*="_formBannerContainer_"] [class*="_formBannerHeading_"] {
    font-family: var(--heading-font-family);
    color: var(--heading-text-color);
  }
  [class*="_formFieldContainer_"],
  [class*="_selectContainer_"] {
    display: flex;
    flex-direction: column;
    gap: 0;
  }
  label[class*="_formInputFieldLabel_"] {
    position: static;
  }
  input[class*="_formInputField_"] {
    order: 1;
  }
  label[class*="_formInputFieldLabel_"],
  p[class*="_label_"],
  div[class*="_formFileInput_"] p[class*="_textBody_"] {
    font: inherit;
    color: rgb(var(--text-color));
    transform: none !important;
    padding-bottom: 5px;
    font-size: 15px;
    -webkit-font-smoothing: antialiased;
  }
  div[class*="_formFileInput_"] div[class*="_formFileInputField_"] {
    margin: 0;
  }
  output[class*="_formError_"] {
    font-family: inherit;
  }
  input[class*="_formInputField_"],
  input[class*="_formPhoneInputField_"],
  button[class*="_selectToggle_"] {
    box-sizing: border-box;
    height: auto;
    padding: var(--input-padding-block) var(--input-padding-inline);
    border: 1px solid rgb(var(--input-text-color) / 0.15);
    border-radius: var(--input-border-radius);
    background: rgb(var(--input-background));
    box-shadow: none;
    color: rgb(var(--input-text-color));
    font-family: inherit;
    font-size: 1rem;
    box-shadow: none !important;
    border: 1px solid rgb(var(--input-text-color) / 0.15) !important;
  }
  [class*="_formPhoneInputContainer_"] {
    row-gap: 6px;
  }
  button[class*="_formSubmitButton_"] {
    border-radius: var(--input-border-radius);
    font-family: inherit;
    font-size: var(--button-font-size);
    width: 100%;
    padding-inline: 0px;
  }
  form[class*="_formFieldset_"] > * [class*="_error_"] {
    font: inherit;
    font-size: 14px;
    margin-top: 5px;
  }
`;

let applied = false;

const applyFormStyles = () => {
  const root = document.querySelector('shopify-forms-embed')?.shadowRoot;

  if (!root) {
    return false;
  }

  if (!applied) {
    applied = true;

    const sheet = new CSSStyleSheet();
    sheet.replaceSync(css);
    root.adoptedStyleSheets = [...root.adoptedStyleSheets, sheet];
  }

  return true;
};

if (!applyFormStyles()) {
  let attempts = 0;

  const timer = setInterval(() => {
    if (applyFormStyles() || (attempts += 1) > 100) {
      clearInterval(timer);
    }
  }, 100);
}